var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "forms-container" }, [
            _c("div", { staticClass: "row no-margin" }, [
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-9 paddingleft0" },
                  [
                    _c(
                      "v-select",
                      {
                        attrs: {
                          name: "locationId",
                          id: "locationId",
                          label: "text",
                          filterable: false,
                          options: _vm.locationArr,
                          clearable: false,
                          placeholder: "Select Location"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "option",
                            fn: function(option) {
                              return [
                                _c("div", { staticClass: "d-center" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(option.text) +
                                      "\n                                    "
                                  )
                                ])
                              ]
                            }
                          },
                          {
                            key: "selected-option",
                            fn: function(option) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "selected d-center" },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(option.text) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.locationId,
                          callback: function($$v) {
                            _vm.locationId = $$v
                          },
                          expression: "locationId"
                        }
                      },
                      [
                        _c("template", { slot: "no-options" }, [
                          _vm._v(
                            "\n                                    Search Location...\n                                "
                          )
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-9 paddingleft0" },
                  [
                    _c(
                      "v-select",
                      {
                        attrs: {
                          name: "locationId",
                          id: "locationId",
                          label: "text",
                          filterable: false,
                          options: _vm.locationArr,
                          placeholder: "Select Location"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "option",
                            fn: function(option) {
                              return [
                                _c("div", { staticClass: "d-center" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(option.text) +
                                      "\n                                    "
                                  )
                                ])
                              ]
                            }
                          },
                          {
                            key: "selected-option",
                            fn: function(option) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "selected d-center" },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(option.text) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.locationId,
                          callback: function($$v) {
                            _vm.locationId = $$v
                          },
                          expression: "locationId"
                        }
                      },
                      [
                        _c("template", { slot: "no-options" }, [
                          _vm._v(
                            "\n                                    Search Location...\n                                "
                          )
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-9 paddingleft0" },
                  [
                    _c(
                      "v-select",
                      {
                        attrs: {
                          name: "locationId",
                          id: "locationId",
                          label: "text",
                          filterable: false,
                          options: _vm.locationArr,
                          placeholder: "Select Location"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "option",
                            fn: function(option) {
                              return [
                                _c("div", { staticClass: "d-center" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(option.text) +
                                      "\n                                    "
                                  )
                                ])
                              ]
                            }
                          },
                          {
                            key: "selected-option",
                            fn: function(option) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "selected d-center" },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(option.text) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.locationId,
                          callback: function($$v) {
                            _vm.locationId = $$v
                          },
                          expression: "locationId"
                        }
                      },
                      [
                        _c("template", { slot: "no-options" }, [
                          _vm._v(
                            "\n                                    Search Location...\n                                "
                          )
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-9 paddingleft0" },
                  [
                    _c("b-form-radio-group", {
                      attrs: { options: _vm.options, name: "radioInline" },
                      model: {
                        value: _vm.selected,
                        callback: function($$v) {
                          _vm.selected = $$v
                        },
                        expression: "selected"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(6),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-9 paddingleft0" },
                  [
                    _c("flat-pickr", {
                      staticClass: "form-control",
                      attrs: { placeholder: "Select date", name: "date" },
                      model: {
                        value: _vm.date,
                        callback: function($$v) {
                          _vm.date = $$v
                        },
                        expression: "date"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(7),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-9 paddingleft0" },
                  [
                    _c("flat-pickr", {
                      staticClass: "form-control",
                      attrs: {
                        config: _vm.config,
                        placeholder: "Select date",
                        name: "date1"
                      },
                      on: {
                        "on-change": _vm.doSomethingOnChange,
                        "on-close": _vm.doSomethingOnClose
                      },
                      model: {
                        value: _vm.date1,
                        callback: function($$v) {
                          _vm.date1 = $$v
                        },
                        expression: "date1"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(8),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-9 paddingleft0" },
                  [
                    _c("flat-pickr", {
                      staticClass: "form-control",
                      attrs: {
                        config: _vm.configStart,
                        placeholder: "Select Start Date"
                      },
                      on: { "on-change": _vm.onStartChange },
                      model: {
                        value: _vm.startDate,
                        callback: function($$v) {
                          _vm.startDate = $$v
                        },
                        expression: "startDate"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(9),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-9 paddingleft0" },
                  [
                    _c("flat-pickr", {
                      staticClass: "form-control",
                      attrs: {
                        config: _vm.configEnd,
                        placeholder: "Select End Date"
                      },
                      on: { "on-change": _vm.onEndChange },
                      model: {
                        value: _vm.endDate,
                        callback: function($$v) {
                          _vm.endDate = $$v
                        },
                        expression: "endDate"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm._m(10),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(11),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-9 paddingleft0" },
                  [
                    _c("date-picker", {
                      staticClass: "form-control",
                      attrs: {
                        placeholder: "Select Date",
                        config: _vm.bootstrapOptions
                      },
                      model: {
                        value: _vm.bootstrapDate,
                        callback: function($$v) {
                          _vm.bootstrapDate = $$v
                        },
                        expression: "bootstrapDate"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(12),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-9 paddingleft0" },
                  [
                    _c("date-picker", {
                      staticClass: "form-control",
                      attrs: {
                        config: _vm.bootstrapOptionsTime,
                        placeholder: "Select Date Time",
                        name: "bootstrapdate1"
                      },
                      model: {
                        value: _vm.bootstrapDate1,
                        callback: function($$v) {
                          _vm.bootstrapDate1 = $$v
                        },
                        expression: "bootstrapDate1"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 forms-block" }, [
                _vm._m(13),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-9 form-input-control paddingleft0" },
                  [
                    _c(
                      "vue-dropzone",
                      {
                        ref: "dropzone",
                        attrs: {
                          id: "dropzone",
                          options: _vm.dropzoneOptions,
                          useCustomSlot: true
                        },
                        on: {
                          "vdropzone-success": _vm.uploadAttachment,
                          "vdropzone-removed-file": _vm.removedSelectedFile
                        }
                      },
                      [
                        _c("div", { staticClass: "dropzone-custom-content" }, [
                          _c("h4", { staticClass: "dropzone-custom-title" }, [
                            _vm._v("Drop files here or click to upload.")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "subtitle" }, [
                            _vm._v("(Select files from your computer.)")
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 forms-block" }, [
                _vm._m(14),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-9 form-input-control paddingleft0" },
                  [
                    _c("tinymce", {
                      ref: "tm",
                      attrs: {
                        plugins: [
                          "advlist autolink lists link image charmap print preview hr anchor pagebreak",
                          "searchreplace wordcount visualblocks visualchars code fullscreen",
                          "insertdatetime media nonbreaking save table contextmenu directionality",
                          "template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample"
                        ],
                        id: "description",
                        other_options: _vm.options
                      },
                      model: {
                        value: _vm.description,
                        callback: function($$v) {
                          _vm.description = $$v
                        },
                        expression: "description"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Forms")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Customer :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Contact :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Collector :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Priority :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 forms-block" }, [
      _c(
        "a",
        {
          attrs: {
            href:
              "https://github.com/ankurk91/vue-flatpickr-component/blob/master/examples/App.vue"
          }
        },
        [_vm._v("Vue FlatPickr Github Demo")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Select Date :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Date Time :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Start Date : ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("End Date:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 forms-block" }, [
      _c(
        "a",
        {
          attrs: {
            href:
              "https://github.com/ankurk91/vue-bootstrap-datetimepicker/blob/master/examples/App.vue"
          }
        },
        [_vm._v("Vue Bootstrap 4 DatetimePicker Github Demo")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Select Date :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Date Time :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 form-title paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Upload Document :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 form-title paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Description :")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3784ae62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3784ae62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms.vue
// module id = null
// module chunks = 